import { PagingMode } from '@wix/wix-data-schema-types';
export default ({ schema, cursorPagingPreferred }) => {
    const collectionSupportsOffsets = schema?.pagingMode?.includes(PagingMode.Offset);
    const collectionSupportsCursors = schema?.pagingMode?.includes(PagingMode.Cursor);
    const collectionSupportsOnlyCursors = schema?.pagingMode?.length === 1 && collectionSupportsCursors;
    const collectionSupportsBothPagingModes = collectionSupportsOffsets && collectionSupportsCursors;
    const pagingMode = collectionSupportsOnlyCursors ||
        (collectionSupportsBothPagingModes && cursorPagingPreferred)
        ? PagingMode.Cursor
        : PagingMode.Offset;
    return pagingMode;
};
//# sourceMappingURL=getPagingMode.js.map